import { useLocation, useSearchParams } from "@remix-run/react";

export function useCreatePageUrl() {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const createPageUrl = (page: number) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('page', page?.toString());
    const newSearch = newSearchParams.toString();
    return `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
  };

  return createPageUrl;
}
